import { useState, useEffect } from 'react';
import { Menu, X, Landmark } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Cómo funciona', href: '#como-funciona' },
  { label: 'Beneficios', href: '#beneficios' },
  { label: 'Planes', href: '#planes' },
  { label: 'Preguntas frecuentes', href: '#faq' },
];

export default function Header({ onEmpezar }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#inicio" className="flex items-center gap-2 font-bold text-navy-900 text-lg">
          <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-navy-900 text-white">
            <Landmark size={18} />
          </span>
          Conciliabanco
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-slate-600 hover:text-navy-900 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            onClick={onEmpezar}
            className="inline-flex items-center rounded-lg bg-brand-green px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-greenDark hover:shadow-md transition-all"
          >
            Empezar ahora
          </button>
        </div>

        <button
          className="md:hidden text-navy-900"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menú"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-slate-100 shadow-lg">
          <nav className="flex flex-col px-6 py-4 gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-sm font-medium text-slate-700 hover:text-navy-900"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={() => { setOpen(false); onEmpezar(); }}
              className="mt-2 rounded-lg bg-brand-green px-5 py-2.5 text-sm font-semibold text-white text-center"
            >
              Empezar ahora
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
